/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { colors } from '../styles/colors';
import * as React from 'react';

export enum Sizing {
  xxs = 8,
  xs = 12,
  sm = 16,
  md = 20,
  default = 24,
  lg = 28,
  xl = 32,
  xxl = 40,
  xxxxl = 80
}

export type Size =
  | 'xxs'
  | 'xs'
  | 'sm'
  | 'md'
  | 'default'
  | 'lg'
  | 'xl'
  | 'xxl'
  | 'xxxxl';

export interface IconProps extends React.SVGAttributes<SVGElement> {
  size?: Size;
}

interface BaseIconProps extends IconProps {
  Icon: React.ComponentType<any>;
}
export const defaultColor = colors.grey100;

export const mapToSize = (size: Size): Sizing => Sizing[size];

export const BaseIcon: React.FC<BaseIconProps> = ({
  Icon,
  size = 'default',
  color = defaultColor,
  ...restProps
}: BaseIconProps) => {
  const dimension = mapToSize(size);
  return (
    <Icon
      aria-hidden={true}
      width={dimension}
      height={dimension}
      color={color}
      focusable="false" /* This is to prevent icons from interfering with tab navigation in IE11 */
      {...restProps}
    />
  );
};
